import { Component, OnInit } from "@angular/core";
import { NgForm } from "@angular/forms";
import { ActivatedRoute } from "@angular/router";
import { ClienteService } from "@core/services/cliente.service";
import { CoreConfigService } from "@core/services/config.service";
import { LeadContatoService } from "@core/services/lead-contato.service";
import { LeadService } from "@core/services/lead.service";
import { AuthenticationService } from "app/auth/service";
import Swal from "sweetalert2";

@Component({
	selector: "app-cadastro-externo",
	templateUrl: "./cadastro-externo.component.html",
	styleUrls: ["./cadastro-externo.component.scss"],
})
export class CadastroExternoComponent implements OnInit {
	email_lead: string;
	cpf_cnpj_lead: string;
	razao_social: string;
	nome_fantasia: string;
	rua: string;
	numero: string;
	complemento: string;
	bairro: string;
	cidade: string;
	estado: string;
	cep: string;
	observacao: string;
	nome_contratante: string;
	telefone_contratante: string;
	email_contratante: string;
	nome_financeiro: string;
	telefone_financeiro: string;
	email_financeiro: string;
	cpf_contratante: string;

	// email_lead: string = 'email@teste.com';
	// cpf_cnpj_lead: string = '12345678900';
	// razao_social: string = 'empresa';
	// nome_fantasia: string = 'fantasia';
	// rua: string = 'rua';
	// numero: string = '123';
	// complemento: string = 'teste';
	// bairro: string = 'centro';
	// cidade: string = 'rio de janeiro';
	// estado: string = 'RJ';
	// cep: string = '20530000';
	// observacao: string = 'OBS';
	// nome_contratante: string = 'contratante';
	// telefone_contratante: string = '21982401100';
	// email_contratante: string = 'e@e.co';
	// nome_financeiro: string = 'fin';
	// telefone_financeiro: string = '21099887766';
	// email_financeiro: string = 'em@m.com';

	lead = {};
	lead_contato_contratante = {};
	lead_contato_financeiro = {};
	tp_cadastro;
	cod_indicador;
	loading = false;

	constructor(
		private leadContatoService: LeadContatoService,
		private clienteService: ClienteService,
		private leadService: LeadService,
		private _coreConfigService: CoreConfigService,
		private _authenticationService: AuthenticationService,
		private route: ActivatedRoute,
	) {
		// Configure the layout
		this._coreConfigService.config = {
			layout: {
				navbar: {
					hidden: true,
				},
				menu: {
					hidden: true,
				},
				footer: {
					hidden: true,
				},
				customizer: false,
				enableLocalStorage: false,
			},
		};
	}

	public submitForm(data: NgForm) {
		this.loading = true;
		if (data.form.status == "VALID") {
			this.lead = {
				tp_cadastro: this.route.snapshot.params.tp_cadastro.toUpperCase(),
				email_lead: this.email_lead.toUpperCase(),
				nome_fantasia: this.nome_fantasia.toUpperCase(),
				razao_social: this.razao_social.toUpperCase(),
				cpf_cnpj_lead: (this.cpf_cnpj_lead.toUpperCase()).replace(/[-.()/,+\s]/g, ""),
				numero: this.numero.toUpperCase(),
				complemento: this.complemento == undefined ? null : this.complemento.toUpperCase(),
				rua: this.rua.toUpperCase(),
				bairro: this.bairro.toUpperCase(),
				cidade: this.cidade.toUpperCase(),
				estado: this.estado.toUpperCase(),
				cep: (this.cep.toUpperCase()).replace(/[-.()/,+\s]/g, ""),
				observacao: this.observacao == undefined ? null : this.observacao.toUpperCase(),
				nome_contratante: this.nome_contratante.toUpperCase(),
				codigo: this.cod_indicador
			};
			this.leadService.create(this.lead).subscribe(
				(res) => {
					let id_lead = res.id_lead

					this.lead_contato_contratante = {
						setor: 'CONTRATANTE',
						cpf_contratante: (this.cpf_contratante.toUpperCase()).replace(/[-.()/,+\s]/g, ""),
						nome: this.nome_contratante.toUpperCase(),
						telefone: (this.telefone_contratante.toUpperCase()).replace(/[-(),+\s]/g, ""),
						email: this.email_contratante.toUpperCase(),
						id_lead: id_lead,
						isDefault: 1,
					}
					this.lead_contato_financeiro = {
						setor: 'FINANCEIRO',
						nome: this.nome_financeiro.toUpperCase(),
						telefone: (this.telefone_financeiro.toUpperCase()).replace(/[-(),+\s]/g, ""),
						email: this.email_financeiro.toUpperCase(),
						id_lead: id_lead,
						isDefault: 0,
					}
					this.leadContatoService.create(this.lead_contato_contratante).subscribe(
						(res) => {
							this.leadContatoService.create(this.lead_contato_financeiro).subscribe(
								(res) => {
									this.loading = false;
									Swal.fire({
										title: "Sucesso!",
										text: "Os dados foram cadastrados.",
										icon: "success",
										confirmButtonText: "Confirmar",
									});
								},
								(err) => {
									this.loading = false;
									console.log(err);
									Swal.fire("Erro!", "Ocorreu um erro ao cadastrar.", "error");
								}
							)
						},
						(err) => {
							this.loading = false;
							console.log(err);
							Swal.fire("Erro!", "Ocorreu um erro ao cadastrar.", "error");
						}
					)

				},
				(error) => {
					this.loading = false;
					if (error.status = 400) {
						Swal.fire("CPF/CNPJ já cadastrado!", "Cliente já cadastrado.", "error");
					} else {
						Swal.fire("Erro!", "Ocorreu um erro ao cadastrar.", "error");
					}
				}
			);

		} else {
			this.loading = false;
			Swal.fire({
				title: "Preencha todos os campos corretamente!",
				icon: "error",
				confirmButtonText: "Confirmar",
			});
		}
	}

	ngOnInit(): void {
		this.tp_cadastro = this.route.snapshot.params.tp_cadastro;
		this.cod_indicador = this.route.snapshot.params.cod_indicador == undefined ? null : this.route.snapshot.params.cod_indicador;
	}
}
